import AdminApproveTransporter from 'views/AdminApproveTransporter/AdminApproveTransporter.jsx';
import AdminApproveTrucker from 'views/AdminApproveTrucker/AdminApproveTrucker.jsx';
import AdminApproveTransaction from 'views/AdminApproveTransaction/AdminApproveTransaction.jsx';
import Transactions from 'views/Transactions/OpsTransactions.jsx';
import Truckers from 'views/Truckers/AdminViewTruckers.jsx';
import DashboardIcon from '@material-ui/icons/Dashboard';
import LocalShipping from '@material-ui/icons/LocalShipping';
import SwapHoriz from '@material-ui/icons/SwapHoriz';
import AssignmentTurnedIn from '@material-ui/icons/AssignmentTurnedIn';
// import AddTransporter from "../views/Users/AddTransporter";
import PayoutsTable from 'views/Transactions/Sections/PayoutsTable.jsx';
import DashboardRedirect from '../views/Dashboard/DashboardRedirect';

const dashRoutes = {
  opsDashRoutes: [
    {
      path: '/ops/dashboard',
      name: 'Dashboard',
      icon: DashboardIcon,
      component: DashboardRedirect,
    },
    {
      collapse: true,
      path: '/ops/approve',
      name: 'Approve',
      icon: AssignmentTurnedIn,
      state: 'openApprove',
      views: [
        {
          path: '/ops/approve/transporter',
          name: 'Transporter',
          mini: 'T',
          component: AdminApproveTransporter,
        },
        {
          path: '/ops/approve/trucker',
          name: 'Trucker',
          mini: 'T',
          component: AdminApproveTrucker,
        },
        {
          path: '/ops/approve/transaction',
          name: 'Transaction',
          mini: 'T',
          component: AdminApproveTransaction,
        },
      ],
    },
    {
      path: '/ops/transactions',
      name: 'View Transactions',
      icon: SwapHoriz,
      component: Transactions,
    },
    {
      path: '/ops/truckers',
      name: 'View Truckers',
      icon: LocalShipping,
      component: Truckers,
    },
    {
      path: '/ops/payouts',
      name: 'Payouts',
      icon: DashboardIcon,
      component: PayoutsTable,
    },
    {
      redirect: true,
      path: '/ops',
      pathTo: '/ops/dashboard',
      name: 'Dashboard',
    },
  ],
  adminDashRoutes: [
    {
      path: '/ops/dashboard',
      name: 'Dashboard',
      icon: DashboardIcon,
      component: DashboardRedirect,
    },
    {
      collapse: true,
      path: '/ops/approve',
      name: 'Approve',
      icon: AssignmentTurnedIn,
      state: 'openApprove',
      views: [
        {
          path: '/ops/approve/transporter',
          name: 'Transporter',
          mini: 'T',
          component: AdminApproveTransporter,
        },
        {
          path: '/ops/approve/trucker',
          name: 'Trucker',
          mini: 'T',
          component: AdminApproveTrucker,
        },
        {
          path: '/ops/approve/transaction',
          name: 'Transaction',
          mini: 'T',
          component: AdminApproveTransaction,
        },
      ],
    },
    {
      path: '/ops/transactions',
      name: 'View Transactions',
      icon: SwapHoriz,
      component: Transactions,
    },

    {
      path: '/ops/truckers',
      name: 'View Truckers',
      icon: LocalShipping,
      component: Truckers,
    },
    {
      path: '/ops/payouts',
      name: 'Payouts',
      icon: DashboardIcon,
      component: PayoutsTable,
    },
    {
      redirect: true,
      path: '/ops',
      pathTo: '/ops/dashboard',
      name: 'Dashboard',
    },
  ],
};
export default dashRoutes;
